var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 text-center" }, [
              _vm.ticket.ritornoInGaranzia
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        " Apri un ticket in funzione della garanzia per l'ultimo danno? "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-5" }, [
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-block btn-lg btn-outline-primary text-center p-5",
                            on: {
                              click: function ($event) {
                                return _vm.siGaranzia()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-2x fa fa-check" }),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n                    SI\n                "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-block btn-lg btn-outline-primary text-center p-5",
                            on: {
                              click: function ($event) {
                                return _vm.noGaranzia()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-2x fa fa-times" }),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n                    NO\n                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }